export const rulesViolated = {
    moneyLaundry: 'Pranie pieniędzy',
    fraud: 'Oszustwo',
    forgery: 'Fałszerstwo',
    theft: 'Kradzież',
    secondOffence: 'Inne przestępstwo',
    dontKnow: 'Nie wiem',
};

